class ForAdult {
  constructor() {
    const newForAdultDOM = document.createElement('div');
    document.body.append(newForAdultDOM);

    newForAdultDOM.outerHTML = `
      <div class="alert__adult" hidden>
        <div class="alert__adult--alert">
          <div class="headline --medium --center">${App.txt.AreYouAdult}</div>
          <p>${App.txt.WarningForAdultOnly}</p>
          <div class="alert__adult--wrapper">
            <button type="submit" class="alert__adult-yes btn --outline --medium">${App.txt.Yes}</button>
            <button type="button" class="alert__adult-no btn --outline --medium">${App.txt.No}</button>
          </div>
        </div>
      </div>
    `;

    setTimeout(() => {
      this.alert = document.querySelector('.alert__adult');
      this.yesButton = this.alert.querySelector('.alert__adult-yes');
      this.noButton = this.alert.querySelector('.alert__adult-no');

      this.noButton.addEventListener('click', () => this.closeModal());
    }, 1)
  }

  openModal(onAcceptClick) {
    this.alert.removeAttribute('hidden');

    this.yesButton.addEventListener('click', onAcceptClick);
    this.onCloseCallback = () => { this.yesButton.removeEventListener('click', onAcceptClick) };
  }

  closeModal() {
    this.alert.setAttribute('hidden', '');

    if (this.onCloseCallback) {
      this.onCloseCallback();
      this.onCloseCallback = null;
    }
  }
}

export default ForAdult;